// @mui
import PropTypes from 'prop-types';
import { Box, Card, Tooltip, Typography } from '@mui/material';
// utils
import { formatCurrency } from '../../../utils/formatNumber';
// components

// ----------------------------------------------------------------------

// const StyledIcon = styled('div')(({ theme }) => ({
//     margin: 'auto',
//     display: 'flex',
//     borderRadius: '50%',
//     alignItems: 'center',
//     width: theme.spacing(8),
//     height: theme.spacing(8),
//     justifyContent: 'center',
//     marginBottom: theme.spacing(3)
// }));

// ----------------------------------------------------------------------

AppWidgetSummary.propTypes = {
    color: PropTypes.string,
    icon: PropTypes.string,
    list: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string,
            amount: PropTypes.number
        })
    ),
    sx: PropTypes.object
};

export default function AppWidgetSummary({
    title,
    list,
    count,
    showOnlyCount = false,
    countTooltip,
    icon,
    color = 'primary',
    sx,
    ...other
}) {
    return (
        <Card
            sx={{
                height: '100%',
                p: 2.5,
                boxShadow: 0,
                textAlign: 'center',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-around',
                color: (theme) => theme.palette[color].darker,
                bgcolor: (theme) => theme.palette[color].lighter,
                ...sx
            }}
            {...other}
        >
            {/*<StyledIcon*/}
            {/*    sx={{*/}
            {/*        color: (theme) => theme.palette[color].dark,*/}
            {/*        backgroundImage: (theme) =>*/}
            {/*            `linear-gradient(135deg, ${alpha(*/}
            {/*                theme.palette[color].dark,*/}
            {/*                0*/}
            {/*            )} 0%, ${alpha(theme.palette[color].dark, 0.24)} 100%)`*/}
            {/*    }}*/}
            {/*>*/}
            {/*    <Iconify icon={icon} width={24} height={24} />*/}
            {/*</StyledIcon>*/}
            <Typography variant="h6" sx={{ opacity: 0.72 }}>
                {title}
            </Typography>

            {showOnlyCount && (
                <Tooltip title={countTooltip} key={countTooltip}>
                    <Typography variant="h4">
                        {formatCurrency(count)}
                    </Typography>
                </Tooltip>
            )}

            {list &&
                list.length &&
                list.map((item, index) => (
                    <Tooltip title={item.tooltip} key={index}>
                        <Box
                            display="flex"
                            flexDirection="column"
                            textAlign="left"
                            key={index}
                        >
                            <Typography
                                variant="subtitle2"
                                sx={{ opacity: 0.72 }}
                            >
                                {item.title}
                            </Typography>
                            <Typography variant="h5">
                                {formatCurrency(item.amount)}
                            </Typography>
                        </Box>
                    </Tooltip>
                ))}
        </Card>
    );
}
